import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const isRealUrl = url => url && url !== 'javascript:;' && !/^javascript:/i.test(url);

const LogoView = errorBoundary(
    class extends React.PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const raw = this.props.content;
            const data = raw && !Array.isArray(raw) ? raw : {};
            const { logo_url, logo_click_url, title, title_click_url } = data;
            let titleNode = null;

            if (title) {
                titleNode = isRealUrl(title_click_url) ? (
                    <a href={title_click_url} target="_blank" rel="noopener noreferrer">
                        {title}
                    </a>
                ) : (
                    title
                );
            }

            return (
                <div className={styles.logoBox2}>
                    {logo_url ? (
                        <a href={logo_click_url || '//www.ifeng.com'} target="_blank" rel="noopener noreferrer">
                            <img className={styles.logo_finace} src={logo_url} alt="凤凰网" />
                        </a>
                    ) : null}
                    {titleNode ? <h1 className={styles.logo_title}>{titleNode}</h1> : null}
                </div>
            );
        }
    },
);

class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={`${styles.logo_box} clearfix`}>
                <Chip id="261186" type="struct" title="Logo" groupName="顶部" content={content}>
                    <LogoView />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(Logo);
